export default __webpack_public_path__ + "static/media/mastercard-single.025ae0d8.svg";